module.exports = __webpack_public_path__ + "img/b3.b465e439.jpg";